import React, { useEffect } from "react";

import CoinItems from "./coinItems";
import photoCoin from "../../../assets/icons/nerkh-seke.svg";
import Spinner from "../../../shared/spinner";

const Coin = ({ data, showSidbarMarginLeft, coinUpdatedAt }) => {
  useEffect(() => {}, [showSidbarMarginLeft]);

  if (data === undefined || data.length === 0) {
    return <Spinner />;
  }
  return (
    <div className=" pt-2 pb-10 ">
      <div
        className=" w-[60%] mx-auto py-4 px-2 text-right  flex flex-row-reverse 
      screen1200:w-[70%] screen1000:w-[86%] screen800:w-[72%] screen700:w-[80%] screen500:w-[90%]"
      >
        <div className="">
          <img
            src={photoCoin}
            alt="سکه صرافی روبین"
            className={` ${
              showSidbarMarginLeft ? "w-8 h-8" : "w-12 h-12 screen370:w-10"
            }`}
          />
        </div>

        <div
          className={` text-white font-bold  my-auto 
        ${
          showSidbarMarginLeft
            ? "text-[9px] mx-2"
            : "text-lg  mx-4 screen500:text-[15px]"
        }
        `}
        >
          نرخ سکه
        </div>
        <div
          className={`text-[#8dd838] my-auto  text-sm font-semibold screen500:text-xs screen450:text-[9px] screen500:-mr-1 
        ${showSidbarMarginLeft && "screen450:hidden"}
        
        `}
        >
          <span className=" screen700:hidden">تاریخ آخرین</span>

          <span className=""> به روز رسانی : </span>

          <span>{coinUpdatedAt?.split(" ")[0]}</span>
          <span className="mx-3 screen450:mx-1">
            {coinUpdatedAt?.split(" ")[1]}
            {/* {+coinUpdatedAt?.split(" ")[1].split(":")[0] +
              1 +
              ":" +
              +coinUpdatedAt?.split(" ")[1].split(":")[1]} */}
          </span>
        </div>
      </div>

      <div
        style={{ direction: "rtl" }}
        className={`grid grid-cols-3  place-items-center gap-3 mx-auto 
         screen500:gap-0 screen500:gap-y-3 
        
        ${
          showSidbarMarginLeft
            ? "grid-cols-1 w-[75%]"
            : "screen800:grid-cols-2 w-[60%] screen1200:w-[70%] screen1000:w-[88%]   screen700:w-[82%] screen500:w-[93%] screen370:w-[100%] "
        }
        `}
      >
        {data.map((item) => {
          return (
            <CoinItems
              key={item.id}
              items={item}
              showSidbarMarginLeft={showSidbarMarginLeft}
            />
          );
        })}
      </div>
    </div>
  );
};

export default Coin;
